import { CrudStoreItemCore } from 'core/classes/services/InitializationServiceCore'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

export const fetchContactHPRoleOptions = (): Promise<string[]> => {
  const source = CrudStore.get(CrudStoreItemCore.Dropdowns, 'HPRoles')
  source.setRoot('HPRoleDropdown')
  source.setPaging({ page: 0, pageSize: 10000 })
  source.setSort([{ field: 'en', dir: 'asc' }])

  return source
    .fetch()
    .then((data) => {
      if (data) {
        return data.items.map((item) => item.value) as string[]
      }

      return [] as string[]
    })
    .catch((error) => {
      Logger.error('Error fetching HPRole options:', error)
      throw error
    })
}
